<template>
  <b-dropdown
    right
    size="sm"
    :text="buttonText"
    class="mr-1"
    v-if="files.length > 0"
  >
    <b-dropdown-item
      v-for="(file, index) in files"
      :key="index"
      :href="`/api/media/file/${file.path}?jwt=${accessToken}`"
      target="_blank"
    >
      {{ file.label }}
    </b-dropdown-item>
  </b-dropdown>
</template>
<script>
export default {
  props: {
    item: Object,
    accessToken: String,
    buttonText: String,
    documentType: String,
  },
  computed: {
    files() {
      if (this.documentType) {
        return Object.values(this.item.files)[0].map((path, index) => ({
          path,
          label: this.typeToLabel(this.documentType, index),
        }));
      }
      return Object.keys(this.item.files)
        .map((type) =>
          this.item.files[type].paths.map((path, index) => ({
            path,
            label: this.typeToLabel(type, index),
          })),
        )
        .flat();
    },
  },
  methods: {
    typeToLabel(type, index) {
      switch (type) {
        case 'picture_before':
          return this.$t('jobs.image.start');
        case 'picture_after':
          return this.$t('jobs.image.finish');
        case 'protocol':
        case 'planning_customer':
        case 'planning_partner':
          return this.$t(`jobs.image.${type}`, { index });
      }
      return this.$t(`projects.image.${type}`);
    },
  },
};
</script>
